import React, { useEffect, useState } from 'react';
import Avatar from './Avatar';
import './OnlineUsers.css';
import { clientCache } from '../services/clientCache';

function OnlineUsers({ currentUser, onlineUsers = [] }) {
  // Always show if there are any users online (including just the current user)
  // if (!onlineUsers.length) {
  //   return (
  //     <div className="connection-status connected">
  //       ● 0 ONLINE
  //     </div>
  //   );
  // }

  // Filter out current user from the dropdown display
  const otherUsers = onlineUsers.filter(user => user.id !== currentUser?.id);
  const [cachedAvatars, setCachedAvatars] = useState({});

  // Try to populate avatars from the client-side cache only.
  // We deliberately avoid firing server requests for every online user to keep traffic low.
  useEffect(() => {
    let mounted = true;
    (async () => {
      const map = {};
      // Check any users (otherUsers + currentUser) for cached avatar
      const listToCheck = onlineUsers.slice(0, 50); // limit iteration in case of very large lists
      for (const u of listToCheck) {
        if (!u) continue;
        if (u.avatar) {
          map[u.id] = u.avatar;
          continue;
        }
        // First try cached user data
        try {
          const cached = await clientCache.getCachedUserData(u.id);
          if (cached && cached.avatar) {
            map[u.id] = cached.avatar;
            continue;
          }
        } catch (err) {
          // ignore
        }

        // Fallback: look for an existing cached booking that contains this user's avatar
        try {
          const cachedBookings = await clientCache.getCachedBookings();
          if (cachedBookings) {
            let found = null;
            // scan grouped bookings for a matching user avatar
            const groups = Object.values(cachedBookings);
            for (let gi = 0; gi < groups.length && !found; gi++) {
              const group = groups[gi];
              for (let bi = 0; bi < group.length; bi++) {
                const b = group[bi];
                const avatar = b?.extendedProps?.userAvatar;
                const uid = b?.extendedProps?.userId || b?.userId || b?.user;
                if (avatar && uid && uid.toString() === u.id.toString()) {
                  found = avatar;
                  break;
                }
              }
            }
            if (found) map[u.id] = found;
          }
        } catch (err) {
          // ignore cache read errors
        }
      }
      if (mounted) setCachedAvatars(map);
    })();
    return () => { mounted = false; };
  }, [onlineUsers]);
  
  return (
    <div className="online-users">
      <div className="online-users-indicator">
        <span className="online-dot"></span>
        <span className="online-count">{onlineUsers.length} ONLINE</span>
      </div>
      <div className="online-users-list">
        {otherUsers.map(user => (
          <div key={user.id} className="online-user">
            <Avatar user={{ ...user, avatar: cachedAvatars[user.id] || user.avatar }} size={32} />
            <span className="user-name">{user.name}</span>
          </div>
        ))}
        <div className="online-user current-user">
          <Avatar user={{ ...currentUser, avatar: cachedAvatars[currentUser?.id] || currentUser?.avatar }} size={32} />
          <span className="user-name">You</span>
        </div>
      </div>
    </div>
  );
}

export default OnlineUsers;
